import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const AnalysisOutcomes = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="analysisout_sec">
        <div className="qep_grad ">
          <h2>Qep Analysis Outcomes</h2>
        </div>
        <div className="analysis_inner_data row mb-3">
          <div className="qep_grad d-flex  justify-content-between  align-items-center pb-3 mt-0">
            <h2 className="mb-0"> Key Data Sources</h2>
            <button type="button" onClick={handleShow}>
              Add Custom Data Source
            </button>
          </div>
          <div className="col-lg-6">
            <div className="analysis_accordion">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Participant Satisfaction Surveys
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul className="acc_desc">
                      <li>
                        <h4>Description:</h4>
                        <p>
                          Quarterly feedback from participants on service
                          quality and coordination experience.
                        </p>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Critical Incident Reports (CIR)
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Policy & Procedure Updates
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="analysis_accordion">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Participant Satisfaction Surveys
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul className="acc_desc">
                      <li>
                        <h4>Description:</h4>
                        <p>
                          Quarterly feedback from participants on service
                          quality and coordination experience.
                        </p>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Critical Incident Reports (CIR)
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Policy & Procedure Updates
                  </Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
        <div className="analysis_inner_data row mb-3">
          <div className="qep_grad ">
            <h2>Data Review Summary</h2>
          </div>
          <ul className="Analysis_sumdata">
            <li>
              {" "}
              Participant satisfaction decreased from 92% in Q1 to 87% in Q2,
              indicating a potential decline in perceived service quality.
            </li>
            <li>
              {" "}
              Provider satisfaction rose to 91%, reflecting improved care
              planning and communication efforts.
            </li>
            <li>
              {" "}
              CIRs increased by 13% this quarter—mainly due to
              medication-related errors and follow-up delays.
            </li>
            <li>
              {" "}
              Timely task closure fell from 97% to 91%, suggesting workflow or
              staffing inefficiencies.
            </li>
            <li>
              {" "}
              92% of staff met monthly training targets; remaining 8% are
              flagged for follow-up.
            </li>
          </ul>
          <div className="goal_left">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              placeholder="Add your interpretation, context, or additional data insights..."
            ></textarea>
          </div>
        </div>
        <div className="analysis_inner_data row mb-3">
          <div className="qep_grad ">
            <h2>Root Cause Analysis & Insights</h2>
            <p>
              Summarize your analysis of why key metrics declined or improved.
              Include staff, policy, or system factors that contributed.
            </p>
          </div>

          <div className="goal_left">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              placeholder="E.g., High turnover disrupted continuity of care; new policy implementation delayed by 3 weeks..."
            ></textarea>
          </div>
        </div>
        <div className="analysis_inner_data row mb-3">
          <div className="qep_grad ">
            <h2>Highlights & Accomplishments</h2>
          </div>
          <ul className="Analysis_sumdata">
            <li>
              95% training compliance achieved three months consecutively – with
              certificates on file.
            </li>
            <li>
              Expanded mobile app features led to 20% higher participant
              check-in rate.
            </li>
            <li>
              Incident follow-up within 48 hours increased from 70% to 94% over
              Q2.
            </li>
            <li>
              Successful onboarding of 5 new staff with 100% completion of
              probationary reviews.
            </li>
            <li>
              All required policy updates acknowledged within 5 business days of
              release.
            </li>
            <li>
              {" "}
              Stakeholder meeting participation increased by 30% following new
              engagement strategy.
            </li>
            <li> Zero audit findings in last state compliance review.</li>
            <li>
              {" "}
              Implemented new transportation tracking tool, reducing missed
              appointments by 15%.
            </li>
            <li>
              {" "}
              Participant portal usage increased 40% after interface
              improvements.
            </li>
          </ul>
          <div className="goal_left">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              placeholder="Add additional agency achievements or improvement highlights..."
            ></textarea>
          </div>
        </div>
        <div className="goalsave_btn meeting_btn">
          <input
            type="submit"
            className="form-control"
            id="exampleFormControlInput1"
            value=" Update"
          />
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className="custom_popup"
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="custom_input_flled ">
            <label className="form-label">Source Name</label>
            <input
              name="teamName"
              placeholder="Enter source name"
              type="text"
              className="form-control mb-3"
              value=""
            />
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="Write a description"
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Frequency</label>
              <input
                name="teamName"
                placeholder="Enter frequency"
                type="text"
                className="form-control"
                value=""
              />
            </div>
            <div className="mb-3">
              <label className="form-label">System</label>
              <input
                name="teamName"
                placeholder="Enter system"
                type="text"
                className="form-control"
                value=""
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AnalysisOutcomes;
